import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useSession } from "../hooks/useSession";
import { rememberReturnPath } from "../session";

/* The guard on every route that assumes a signed-in user.

   Renders nothing until the SDK reports session state. Flashing the app shell
   and then bouncing to /login is worse than a blank frame, and the wait is one
   synchronous read of persistent storage, not a round trip. A page opened signed out (a link to
   a chat, a Settings section) is where sign-in comes back to. */
export default function RequireAuth({ children }: { children: React.ReactNode }) {
  const { isInitialized, isAuthenticated } = useSession();
  const { pathname, search, hash } = useLocation();
  if (!isInitialized) return null;
  if (!isAuthenticated) {
    // the hash too: an old link (a notice's `/?org=…#/chat/…`) is rewritten after sign-in
    rememberReturnPath(pathname + search + hash);
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}
